import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { PublicBoxComponentGroupCosmeticResponse } from './public-box-component-group-cosmetic.response';

@jsonObject
export class PublicBoxComponentGroupResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Boolean)
  public readonly isVisibleInQuestionnaire!: boolean;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonArrayMember(PublicBoxComponentGroupCosmeticResponse)
  public readonly cosmetics!: PublicBoxComponentGroupCosmeticResponse[];
}
